import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { UnauthenticatedSession } from '@iwentsourcing/client/oauth/unauthenticated-session.js';
import { AuthenticatedSession } from '@iwentsourcing/client/oauth/authenticated-session.js';
import { Router, RouterLink } from '@angular/router';
import { signalFromDestroyRef } from '../../signal-from-destroy-ref.js';
import { ApiService } from '../../api.service.js';
import { AuthConfig } from '../../provide-api.js';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
})
export class NavbarComponent implements OnInit {
  api = inject(ApiService);
  router = inject(Router);
  destroyRef = inject(DestroyRef);
  signal = signalFromDestroyRef(this.destroyRef);
  authConfig = inject(AuthConfig);

  apiState = this.api.create(this.authConfig.tenant, this.authConfig.realm);

  session = signal<AuthenticatedSession | UnauthenticatedSession>({
    type: 'unauthenticated',
  });

  ngOnInit() {
    this.apiState.remote.session.on((evt) => {
      if (evt.type === 'authenticated' || evt.type === 'unauthenticated') {
        this.session.set(evt);
      }
    }, this.signal);
  }

  async logout() {
    await this.apiState.remote.session.logout();
    await this.router.navigate(['/login']);
  }
}
